import Vue from 'vue'
import Router from 'vue-router'

import HomeRoutes from './home'
import AdminRoutes from './adminpoint'
import CreateSellpointRoutes from './createsellpoint'
import BusinessesRoutes from './businesses'
import SearchRoutes from './search'
import GetStartedRoutes from './getstarted'
import PurchaseRoutes from './purchase'
import RegisterRoutes from './register'
import LoginRoutes from './login'
import AccountRoutes from './account'
import SellpointRoutes from './sellpoint'
import BuypointRoutes from './buypoint'
import OrderpointRoutes from './orderpoint'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        LoginRoutes,
        HomeRoutes,
        AdminRoutes,
        CreateSellpointRoutes,
        BusinessesRoutes,
        SearchRoutes,
        GetStartedRoutes,
        PurchaseRoutes,
        RegisterRoutes,
        AccountRoutes,
        BuypointRoutes,
        OrderpointRoutes,
        SellpointRoutes,
        {path: '*', redirect: '/'} // 404
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js